import useEvent from "react-use-event-hook";
import { useSetRecoilState } from "recoil";

import {
  isEntityServerSidePaginated,
  shiftRowsCount,
  tableRowsCountAtomFamily,
  type RydeUiUnit,
} from "@ryde/shared";

/** A server-paged grid shows the server total, so rows added to or removed from its loaded page move it too. */
export const useShiftServerRowsCount = (entity: RydeUiUnit) => {
  const setTableRowsCount = useSetRecoilState(tableRowsCountAtomFamily(entity));
  const isServerPaginated = isEntityServerSidePaginated(entity);

  const shiftServerRowsCount = useEvent((delta: number): void => {
    if (!isServerPaginated) {
      return;
    }

    setTableRowsCount(count => shiftRowsCount({ count, delta }));
  });

  return { shiftServerRowsCount };
};
